module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABOUlEQVQ4jaXTPy8EQRjH8e9dvACtYhSiUwiRkFBJRGIazp9oKKlkJLR6GoxEodCLECSexjugEKLTSEwrUWkIKyO7cvbmJrvnV22emf08k51nK0mSEIq2bgGYB3qAKvAInIlR+6H9DZC2rg24BMaDHeDWr4lRL/XFamDjUQTx6Qeu8sU/kLZuGJiOIFn6tHWLsROtFkCyrMSgzhJQRwx6LwF9xKDrEtBDDNosAW00hdLZWC6AbIlR9/WF4GRr62rAIdCeW/LfZV2M2su/E5rsOTHqOH0eA0YAP+03YtRFWp8BTsWoJAhp6zwwC7wCS2LUSa7JKHAAdPuLEaOGGiBt3U6TgXwCPoGuwOWci1FTv5C2btL/2QGkSNbEqO2sgz9Nq/kZmcrE7nMvcPcPyKfmb2MQeAO+WmZg4BsUgmPb5vqNTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_per.png
// module id = rYfy
// module chunks = 3